// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"9bc35f3c","623":"9bc35f3c","655":"9bc35f3c","885":"4962098d"}[chunkId] + ".chunk.css";
};